<template>
  <div class="flex flex-column align-items-start">
    <b v-if="label">{{ label }}</b>
    <a-tag :color="status.color">
      {{ status.title }}
    </a-tag>

    <div v-if="flags.length" class="flex flex-column gap-2 mt-2 w-full">
      <a-tag @click.stop="$emit('handleClick', flag.key)" v-for="flag in flags" :key="flag.key" color="#ef4444">
        {{ flag.info.title }}
      </a-tag>
    </div>
  </div>
</template>
<script>
import { Tag } from 'ant-design-vue'

export default {
  name: 'PaymentInfoBlock',
  components: {
    'a-tag': Tag
  },
  props: {
    label: {
      type: String,
      default: undefined
    },
    status: {
      type: Object,
      required: true,
      validator: val => 'color' in val && 'title' in val
    },
    flags: {
      type: Array,
      default: () => []
    }
  }
}
</script>
